(function() {
  'use strict';

  var DESKTOP_MQ = '(min-width: 990px)';

  function generateSlug(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function findH2Elements() {
    var selectors = [
      '.main-article__body h2',
      '.main-article__content h2',
      '.main-article h2',
      '.rte h2'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var elements = document.querySelectorAll(selectors[i]);
      if (elements.length > 0) {
        return Array.prototype.filter.call(elements, function(h2) {
          var header = h2.closest('header');
          return !header || !header.classList.contains('main-article__header');
        });
      }
    }

    return [];
  }

  function syncTocOpenState(tocNav) {
    if (!tocNav) return;
    // Desktop: always expanded. Mobile: collapsed by default (accordion).
    tocNav.open = window.matchMedia(DESKTOP_MQ).matches;
  }

  function initTableOfContents() {
    var tocList = document.getElementById('article-toc-list');
    var tocSidebar = document.getElementById('article-toc-sidebar');
    var tocNav = document.getElementById('article-toc-nav');

    if (!tocList || !tocSidebar) {
      return false;
    }

    var h2Elements = findH2Elements();

    if (h2Elements.length === 0) {
      tocSidebar.style.display = 'none';
      return false;
    }

    tocList.innerHTML = '';
    tocSidebar.style.display = 'block';
    syncTocOpenState(tocNav);

    h2Elements.forEach(function(h2, index) {
      var text = h2.textContent.trim();
      if (!text) return;

      var id = h2.id || ('toc-heading-' + (index + 1));

      if (!h2.id) {
        var slug = generateSlug(text);
        h2.id = slug || id;
      }

      var listItem = document.createElement('li');
      listItem.className = 'main-article__toc-item';

      var link = document.createElement('a');
      link.href = '#' + h2.id;
      link.textContent = text;
      link.className = 'main-article__toc-link';
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var targetElement = document.getElementById(h2.id);
        if (targetElement) {
          var offsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        }
        // Collapse accordion after jump on mobile
        if (tocNav && !window.matchMedia(DESKTOP_MQ).matches) {
          tocNav.open = false;
        }
      });

      listItem.appendChild(link);
      tocList.appendChild(listItem);
    });

    function updateActiveSection() {
      var scrollPosition = window.pageYOffset + 150;
      var currentActive = null;

      h2Elements.forEach(function(h2) {
        var elementTop = h2.getBoundingClientRect().top + window.pageYOffset;
        if (scrollPosition >= elementTop) {
          currentActive = h2.id;
        }
      });

      var tocLinks = tocList.querySelectorAll('.main-article__toc-link');
      tocLinks.forEach(function(link) {
        var targetId = link.getAttribute('href').replace('#', '');
        if (targetId === currentActive) {
          link.classList.add('main-article__toc-link--active');
        } else {
          link.classList.remove('main-article__toc-link--active');
        }
      });
    }

    var ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          updateActiveSection();
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', function() {
      syncTocOpenState(tocNav);
    });
    updateActiveSection();

    return true;
  }

  function tryInit() {
    if (initTableOfContents()) {
      return true;
    }

    setTimeout(function() {
      if (!initTableOfContents()) {
        setTimeout(initTableOfContents, 500);
      }
    }, 100);

    return false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }

  if (window.MutationObserver) {
    var observer = new MutationObserver(function() {
      var tocList = document.getElementById('article-toc-list');
      if (tocList && tocList.children.length === 0) {
        initTableOfContents();
      }
    });

    var articleContent = document.querySelector('.main-article__content') ||
      document.querySelector('.main-article__body') ||
      document.querySelector('.main-article');

    if (articleContent) {
      observer.observe(articleContent, {
        childList: true,
        subtree: true
      });
    }
  }
})();
